export default class Form {
  constructor(form) {
    this.form = form;
  }

  disable() {
    this.submitButtons().forEach((button) => {
      button.disabled = true;
      if (!button.dataset.disableWith) return;

      button.dataset.originalContent = button.innerHTML;
      button.innerHTML = button.dataset.disableWith;
    });
  }

  enable() {
    this.restoreButtonContent();
    this.submitButtons().forEach((button) => { button.disabled = false; });
  }

  reset() {
    this.restoreButtonContent();
    this.submitButtons().forEach((button) => { button.disabled = true; });
  }

  submitButtons() {
    return this.form.querySelectorAll('button[type=submit]');
  }

  restoreButtonContent() {
    this.submitButtons().forEach((button) => {
      if (!button.dataset.originalContent) return;

      button.innerHTML = button.dataset.originalContent;
      delete button.dataset.originalContent;
    });
  }
}
